export default function cloneDeep(data) {
  if (typeof window.structuredClone === 'function') {
    return window.structuredClone(data);
  }
  return JSON.parse(JSON.stringify(data));
}